import React from 'react';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { selectSpin } from 'Douleutaras/redux/data/ui/spinSlice';

import './Spin.scss';

export const Spin = ({ children, className = '' }) => {
  const loading = useAppSelector(selectSpin);

  return (
    <div styleName="spin__container" className={className}>
      { loading &&
        <div styleName="spin__wrapper">
          <div styleName="spin__overlay" />
          <div styleName="spin" />
        </div>
      }
      { children }
    </div>
  );
};
